/* Pendelle — JS propre à la zone product (fichier de l’agent FICHE PRODUIT). Chargé en defer après pendelle.js (window.PD disponible).
   Reprend la logique de la maquette (fiches pg-orbe / pg-arche) sur les vraies données Shopify :
   - options en pastilles → variante (prix, 3 fois sans frais, disponibilité, adresse ?variant=) ;
   - photos de la finition choisie (comme imgs() de la maquette), miniatures, flèches, compteur, zoom au survol,
     agrandissement (calque #ovZoom), carrousel + points en mobile, galerie empilée ;
   - taille → surface conseillée, petit plan, tableau « Dimensions et poids », schéma coté (section pd-pdp-dims) ;
   - quantité → champ du formulaire d’ajout (data-pd-add → panier latéral de BASE).
   Événements : 'pd:size' (detail {product, g}) émis à chaque taille ; 'pd:pick-size' (detail {product, g}) écouté. */
(function () {
  'use strict';
  var PD = window.PD = window.PD || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }

  /* ------------------------------------------------------------ images (CDN Shopify : paramètre width) */
  function srcW(u, w) {
    u = String(u || '');
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcset(m, ws) {
    var ok = ws.filter(function (w) { return !m.w || w <= m.w; });
    if (!ok.length) ok = [m.w || ws[0]];
    return ok.map(function (w) { return srcW(m.u, w) + ' ' + w + 'w'; }).join(', ');
  }
  function imgTag(m, ws, sizes, eager, alt) {
    var big = ws[ws.length - 1]; if (m.w && big > m.w) big = m.w;
    return '<img src="' + esc(srcW(m.u, big)) + '" srcset="' + esc(srcset(m, ws)) + '" sizes="' + esc(sizes) + '" alt="' + esc(alt) + '" loading="' + (eager ? 'eager' : 'lazy') + '" width="' + (m.w || 1600) + '" height="' + (m.h || 2000) + '">';
  }

  /* ------------------------------------------------------------ fiche produit */
  function Pdp(root) {
    if (!root || root.__pdp) return; root.__pdp = 1;
    var js = $('[data-pd-json]', root); if (!js) return;
    var data; try { data = JSON.parse(js.textContent); } catch (e) { return; }
    var V = data.variants || [], M = (data.media || []).slice().sort(function (a, b) { return a.pos - b.pos; }), O = data.opts || {};
    var scope = root.closest('.shopify-section') || root.parentNode || document;
    var form = $('form[data-pd-add]', root);
    var vid = form && $('[data-vid]', form), qin = form && $('[data-qin]', form);
    var addBtn = form && $('button[type=submit]', form), addLbl = addBtn && $('[data-add-label]', addBtn);
    var lAdd = addBtn ? addBtn.getAttribute('data-l-add') : '', lSold = addBtn ? addBtn.getAttribute('data-l-sold') : '';
    var sticky = $('.pd-sticky', scope), stickyBtn = sticky && $('button', sticky);
    var gal = $('[data-gal]', root), mode = gal ? gal.getAttribute('data-gal') : 'thumbs';
    var th = $('[data-g-thumbs]', root), st = $('[data-g-stack]', root), sl = $('[data-g-slider]', root), dots = $('[data-g-dots]', root);
    var byId = {}; M.forEach(function (m) { byId[m.id] = m; });
    var vImgPos = {}; V.forEach(function (x) { if (x.media && byId[x.media]) vImgPos[byId[x.media].pos] = 1; });
    var cur = null, G = { list: [], i: 0 };
    var initId = vid ? +vid.value : 0;
    V.forEach(function (x) { if (x.id === initId) cur = x; });
    if (!cur) cur = V[0];
    if (!cur) return;

    /* photos d'une variante : TOUTES les photos restent dans la galerie ; celle de la variante choisie passe en premier,
       les autres gardent leur ordre d'origine (variante sans photo dédiée : ordre d'origine) */
    function order(v) {
      var all = M.slice();
      var vm = v && v.media && byId[v.media];
      if (!vm) return all;
      return [vm].concat(all.filter(function (m) { return m !== vm; }));
    }

    function sameList(a, b) { if (a.length !== b.length) return false; for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false; return true; }
    function domIds() {
      var a = gal ? String(gal.getAttribute('data-ids') || '') : '';
      return a.split(',').filter(Boolean).map(Number);
    }

    function renderGallery(list, keepDom) {
      if (!list.length) return;
      G.list = list; G.i = 0;
      var n = list.length;
      if (!keepDom) {
        if (th) {
          th.hidden = n < 2;
          th.innerHTML = n > 1 ? list.map(function (m, i) {
            return '<button type="button" class="th" data-th="' + i + '" aria-current="' + (i === 0) + '" aria-label="Photo ' + (i + 1) + ' sur ' + n + '"><span class="fr">' + imgTag(m, [120, 160, 240], '76px', false, '') + '</span></button>';
          }).join('') : '';
          if (mode === 'thumbs' && gal) gal.style.gridTemplateColumns = n < 2 ? 'minmax(0,1fr)' : '';
        }
        if (st) {
          st.innerHTML = list.map(function (m, i) {
            var sz = i % 3 === 0 ? '(min-width: 1100px) 50vw, (min-width: 760px) 55vw, 100vw' : '(min-width: 1100px) 25vw, (min-width: 760px) 28vw, 50vw';
            return '<div class="fr" data-zoomk="' + m.id + '" role="button" tabindex="0" aria-label="Agrandir la photo ' + (i + 1) + '">' + imgTag(m, [450, 600, 900, 1200, 1600], sz, i === 0, m.alt) + '</div>';
          }).join('');
        }
        if (sl) {
          sl.innerHTML = list.map(function (m, i) { return '<div class="fr">' + imgTag(m, [375, 560, 750, 900, 1200], '100vw', i === 0, m.alt) + '</div>'; }).join('');
          sl.scrollLeft = 0;
        }
        if (dots) dots.innerHTML = n > 1 ? list.map(function (m, i) { return '<i' + (i === 0 ? ' class="on"' : '') + '></i>'; }).join('') : '';
        var mp = $('.mainph', root);
        if (mp) {
          var c = $('[data-g-count]', mp);
          if (n > 1 && !c) { c = document.createElement('span'); c.className = 'count'; c.setAttribute('data-g-count', ''); var ctrl = $('.ctrl', mp); mp.insertBefore(c, ctrl); }
          if (c) c.hidden = n < 2;
          $$('[data-gprev],[data-gnext]', mp).forEach(function (b) { b.hidden = n < 2; });
        }
        showImg(0, true);
      } else {
        var cc = $('[data-g-count]', root); if (cc) cc.textContent = '1 / ' + n;
      }
      /* photo de la barre collante */
      var sim = sticky && $('.fr img', sticky);
      if (sim) { sim.srcset = srcset(list[0], [92, 138]); sim.src = srcW(list[0].u, 138); }
    }

    function showImg(i, instant) {
      var n = G.list.length; if (!n) return;
      i = ((i % n) + n) % n; G.i = i; var m = G.list[i];
      var im = $('.mainph .fr img', root);
      if (im) {
        var set = function () {
          im.removeAttribute('loading');
          im.srcset = srcset(m, [600, 900, 1200, 1600, 2000]); im.src = srcW(m.u, 1600);
          im.alt = m.alt || ''; if (m.w) { im.width = m.w; im.height = m.h; }
          im.style.opacity = '1';
        };
        if (instant || RM) set(); else { im.style.opacity = '0'; setTimeout(set, 160); }
      }
      $$('.th', root).forEach(function (t, j) { t.setAttribute('aria-current', String(j === i)); });
      var c = $('[data-g-count]', root); if (c) c.textContent = (i + 1) + ' / ' + n;
    }

    function zoom(m) {
      if (!m) return;
      var z = document.getElementById('zoomImg'); if (!z) return;
      z.src = srcW(m.u, 2400); z.alt = m.alt || '';
      if (PD.openLayer) PD.openLayer('ovZoom');
    }

    /* disponibilité des pastilles (comme Horizon : selon les autres options choisies) */
    function markAvail() {
      $$('[data-opt]', root).forEach(function (b) {
        var oi = +b.getAttribute('data-opt'), val = b.getAttribute('data-v');
        var ok = V.some(function (x) {
          if (!x.available || x.options[oi] !== val) return false;
          for (var j = 0; j < x.options.length; j++) if (j !== oi && x.options[j] !== cur.options[j]) return false;
          return true;
        });
        b.classList.toggle('disabled', !ok);
      });
    }

    function sizeUpdate() {
      if (O.size < 0) return;
      var chip = $('[data-opt="' + O.size + '"][aria-pressed="true"]', root);
      var box = $('[data-surf-box]', root);
      var g = chip && chip.hasAttribute('data-g') ? +chip.getAttribute('data-g') : -1;
      if (box) {
        var b = $('[data-surf]', box), p = $('[data-surfp]', box), pl = $('[data-plan]', box);
        var sb = g > -1 ? chip.getAttribute('data-surf') : box.getAttribute('data-surf0');
        var sp = g > -1 ? chip.getAttribute('data-surfp') : box.getAttribute('data-surfp0');
        if (b && sb) b.textContent = sb;
        if (p) { p.textContent = sp || ''; p.hidden = !sp; }
        if (pl && g > -1) pl.style.setProperty('--d', chip.getAttribute('data-pd') + 'px');
        if (PD.nb) PD.nb(box);
      }
      if (g > -1) {
        $$('.spec [data-g]', root).forEach(function (tb) { tb.hidden = +tb.getAttribute('data-g') !== g; });
        emit('pd:size', { product: data.id, g: g });
      }
    }

    function setVariant(v, init) {
      var prev = cur; cur = v;
      if (vid) vid.value = v.id;
      $$('[data-opt-box]', root).forEach(function (box) {
        var oi = +box.getAttribute('data-opt-box'), val = v.options[oi];
        var lab = $('[data-val]', box); if (lab) lab.textContent = val;
        $$('[data-opt]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === val)); });
      });
      markAvail();
      if (PD.updatePrices) PD.updatePrices(scope, v);
      if (addBtn) { addBtn.disabled = !v.available; if (addLbl) addLbl.textContent = v.available ? lAdd : lSold; addBtn.setAttribute('aria-label', (v.available ? lAdd : lSold) + ' : ' + (addBtn.getAttribute('data-name') || '')); }
      if (stickyBtn) stickyBtn.disabled = !v.available;
      sizeUpdate();
      if (init || !prev || (v.media && prev.media !== v.media)) {
        var list = order(v);
        if (init) renderGallery(list, sameList(domIds(), list.map(function (m) { return m.id; })));
        else renderGallery(list, false);
      }
      if (!init && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      }
    }

    function pick(oi, val) {
      var want = cur.options.slice(); want[oi] = val;
      var best = null, bestS = -1, bestA = null, bestAS = -1;
      V.forEach(function (x) {
        if (x.options[oi] !== val) return;
        var s = 0; for (var j = 0; j < want.length; j++) if (x.options[j] === want[j]) s++;
        if (s > bestS) { bestS = s; best = x; }
        if (x.available && s > bestAS) { bestAS = s; bestA = x; }
      });
      var v = (best && best.available) ? best : (bestA || best);
      if (v) setVariant(v, false);
    }

    /* clics */
    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-opt]'))) { e.preventDefault(); pick(+b.getAttribute('data-opt'), b.getAttribute('data-v')); return; }
      if ((b = t.closest('[data-th]'))) { showImg(+b.getAttribute('data-th')); return; }
      if (t.closest('[data-gprev]')) { showImg(G.i - 1); return; }
      if (t.closest('[data-gnext]')) { showImg(G.i + 1); return; }
      if (t.closest('[data-gzoom]') || t.closest('.mainph .fr[data-zoomable]')) { zoom(G.list[G.i]); return; }
      if ((b = t.closest('[data-zoomk]'))) { zoom(byId[+b.getAttribute('data-zoomk')]); return; }
    });
    root.addEventListener('keydown', function (e) {
      var b = e.target.closest && e.target.closest('[data-zoomk]');
      if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); zoom(byId[+b.getAttribute('data-zoomk')]); }
    });
    /* zoom au survol de la photo principale (maquette) */
    var mf = $('.mainph .fr[data-zoomable]', root);
    if (mf) {
      mf.addEventListener('mousemove', function (e) {
        if (!window.matchMedia('(hover:hover)').matches) return;
        var r = mf.getBoundingClientRect(), im = $('img', mf); if (!im) return;
        im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        mf.classList.add('zoom');
      });
      mf.addEventListener('mouseleave', function () { mf.classList.remove('zoom'); });
    }
    /* carrousel mobile → points */
    if (sl && dots) sl.addEventListener('scroll', function () {
      var i = Math.round(sl.scrollLeft / Math.max(1, sl.clientWidth));
      $$('i', dots).forEach(function (d, j) { d.classList.toggle('on', j === i); });
    }, { passive: true });
    /* quantité → champ du formulaire, juste avant l'envoi (le formulaire passe ensuite par PD.addForm) */
    if (form) form.addEventListener('submit', function () {
      var out = $('[data-qty] output', form);
      if (qin && out) qin.value = Math.max(1, parseInt(out.textContent, 10) || 1);
    });
    /* bascule du schéma coté (section pd-pdp-dims) */
    document.addEventListener('pd:pick-size', function (e) {
      var d = e.detail || {}; if (d.product !== data.id || O.size < 0) return;
      var chip = $('[data-opt="' + O.size + '"][data-g="' + d.g + '"]', root);
      if (chip) pick(O.size, chip.getAttribute('data-v'));
    });

    setVariant(cur, true);
  }

  /* ------------------------------------------------------------ schéma coté (maquette : drawOrbe) */
  function Dims(sec) {
    if (!sec || sec.__pdd) return; sec.__pdd = 1;
    var pid = +sec.getAttribute('data-pd-dims');
    var btns = $$('[data-dtgl]', sec), svg = $('svg', sec); if (!svg || !btns.length) return;
    var ds = btns.map(function (b) { return +b.getAttribute('data-d') || 0; }).filter(function (d) { return d > 0; });
    var dmax = ds.length ? Math.max.apply(null, ds) : 0, dmin = ds.length ? Math.min.apply(null, ds) : 0;
    var ring = $('[data-ring]', svg), gl = $('[data-globes]', svg), cab = $('[data-cables]', svg), sh = $('[data-shade]', svg);
    var w = $('[data-w]', svg), hp = $('[data-h]', svg), wt = $('[data-wt]', svg), ht = $('[data-ht]', svg);
    function draw(g) {
      var b = btns.filter(function (x) { return +x.getAttribute('data-dtgl') === g; })[0] || btns[0];
      var n = +b.getAttribute('data-n') || 0, d = +b.getAttribute('data-d') || 0;
      var rx = (ds.length > 1 && dmax > dmin && d > 0) ? 105 + (d - dmin) / (dmax - dmin) * 35 : 140;
      rx = Math.round(rx * 10) / 10;
      if (n > 0) {
        var r = n <= 6 ? 22 : (n <= 12 ? 17 : 13), html = '';
        for (var i = 0; i < n; i++) {
          var a = (i / n) * Math.PI * 2 + .3, x = 260 + Math.cos(a) * rx, y = 300 + Math.sin(a) * 20 - (n >= 10 && i % 2 ? 28 : 0);
          html += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + r + '"/>';
        }
        gl.innerHTML = html; ring.setAttribute('rx', rx); ring.setAttribute('ry', 20);
        cab.setAttribute('d', 'M255 50 160 300M265 50 360 300M260 50v240'); sh.setAttribute('d', '');
      } else {
        gl.innerHTML = ''; ring.setAttribute('rx', rx); ring.setAttribute('ry', 14);
        sh.setAttribute('d', 'M' + (260 - rx) + ' 300C' + (260 - rx) + ' ' + (300 - rx) + ' ' + (260 + rx) + ' ' + (300 - rx) + ' ' + (260 + rx) + ' 300Z');
        cab.setAttribute('d', 'M260 50V' + Math.round(300 - rx * 0.75));
      }
      var L = Math.round((260 - rx - 26) * 10) / 10, R = Math.round((260 + rx + 26) * 10) / 10;
      w.setAttribute('d', 'M' + L + ' 370h' + Math.round((R - L) * 10) / 10 + 'M' + L + ' 362v16M' + R + ' 362v16');
      wt.textContent = b.getAttribute('data-wt') || '';
      var h = b.getAttribute('data-ht') || '';
      hp.style.display = h ? '' : 'none'; ht.textContent = h;
      btns.forEach(function (x) { if (x.tagName === 'BUTTON') x.setAttribute('aria-pressed', String(x === b)); });
    }
    btns.forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function () { var g = +b.getAttribute('data-dtgl'); draw(g); emit('pd:pick-size', { product: pid, g: g }); });
    });
    document.addEventListener('pd:size', function (e) { var d = e.detail || {}; if (d.product === pid) draw(d.g); });
    var on = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
    draw(+on.getAttribute('data-dtgl'));
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-pd-pdp]', scope).forEach(Pdp);
    $$('[data-pd-dims]', scope).forEach(Dims);
  }
  PD.initProduct = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
